import React, { useState, useEffect, useContext } from "react";
import { Modal, Input, Upload, Button, Form, InputNumber, Select, Image } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { AuthContext } from "../../context/AuthContext";
import listApi from "../../services/api";

const { Option } = Select;

const ProductModal = ({ visible, onClose, product, fetchProducts }) => {
  const { userData } = useContext(AuthContext);
  const [form] = Form.useForm();
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [currentImage, setCurrentImage] = useState(""); // Ảnh sản phẩm hiện tại
  const [previewImage, setPreviewImage] = useState(""); // Ảnh mới tải lên
  const [listType, setListType] = useState([]);

  useEffect(() => {
    listProductType();
    if (product) {
      form.setFieldsValue({
        product_name: product.name,
        product_type: product.type,
        number: product.number,
        price: product.price,
        ship: product.ship,
      });
      setDescription(product.product_info || "");
      setCurrentImage(product.image || ""); // Lưu ảnh sản phẩm hiện tại
      setPreviewImage(""); // Xóa ảnh xem trước khi mở modal
    } else {
      form.resetFields();
      setDescription("");
      setSelectedFile(null);
      setCurrentImage(""); // Không có ảnh nếu thêm sản phẩm mới
      setPreviewImage("");
    }
  }, [product, form, userData]);


  const listProductType = async () => {
    try {
      const response = await fetch(listApi.listProductType,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            session_id: userData.session_id
          })
        });
      const data = await response.json();
      if (data.code === 200) {
        setListType(data.list_product_type)

      }
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
  };

  const handleFileChange = ({ fileList }) => {
    if (fileList.length === 0) {
      setSelectedFile(null);
      setPreviewImage("");
      return;
    }

    const file = fileList[0]; // Chỉ lấy 1 ảnh
    console.log("File được chọn:", file);

    if (file.originFileObj) {
      setSelectedFile(file.originFileObj);
      setPreviewImage(URL.createObjectURL(file.originFileObj));
    } else {
      console.warn("Không tìm thấy originFileObj trong file!", file);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (!values.product_name || !values.product_type || !values.number || !values.price) {
        alert("Vui lòng điền đầy đủ thông tin trước khi lưu sản phẩm!");
        return;
      }
      let selectedType = values.product_type;

      // Kiểm tra nếu product_type không phải là ID thì tìm lại ID từ name
      if (typeof selectedType === "string") {
        const foundType = listType.find((item) => item.name === selectedType);
        if (foundType) {
          selectedType = foundType.ID;
        }
      }
      const formData = new FormData();
      formData.append("session_id", userData.session_id);
      formData.append("product_name", values.product_name);
      formData.append("product_type", selectedType);
      formData.append("product_info", description);
      formData.append("number", values.number);
      formData.append("price", values.price);

      if (product) {
        formData.append("product_id", product.id);
      }


      if (selectedFile) {
        console.log("Gửi ảnh lên API:", selectedFile);
        formData.append("file", selectedFile);
      } else {
        console.warn("Chưa chọn ảnh!");
      }

      const url = product ? listApi.editProduct : listApi.addProduct;
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      console.log("Kết quả:", result);

      if (result.code === 200) {
        alert(product ? "Sản phẩm đã được cập nhật!" : "Sản phẩm đã được tạo!");
        if (fetchProducts) {
          fetchProducts(); // Làm mới danh sách sản phẩm
        }
        onClose();
      } else {
        alert(`Lỗi: ${result.desc || "Không thể xử lý sản phẩm"}`);
      }
    } catch (error) {
      console.error("Lỗi khi xử lý sản phẩm:", error);
    }
  };


  return (
    <Modal
      title={product ? "CHỈNH SỬA SẢN PHẨM" : "ĐIỀN THÔNG TIN SẢN PHẨM MỚI"}
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={product ? "Cập nhật sản phẩm" : "Lưu sản phẩm"}
      cancelText="Hủy bỏ"

      width={700}
    >
      <Form form={form} layout="vertical" initialValues={{
        product_type: product ? product.product_type : undefined, // Phải là ID
      }}>
        <Form.Item
          label="Tên sản phẩm:"
          name="product_name"
          rules={[{ required: true, message: "Vui lòng nhập tên sản phẩm!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Loại sản phẩm:"
          name="product_type"
          rules={[{ required: true, message: "Vui lòng chọn loại sản phẩm!" }]}
        >
          <Select placeholder="Chọn loại sản phẩm">
            {listType.map((item) => (
              <Option key={item.ID} value={item.ID}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Số lượng:"
          name="number"
          rules={[{ required: true, message: "Vui lòng nhập số lượng!" }]}
        >
          <InputNumber min={1} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Giá sản phẩm:"
          name="price"
          rules={[{ required: true, message: "Vui lòng nhập giá!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item label="Mô tả sản phẩm:">
          <ReactQuill value={description} onChange={setDescription} />
        </Form.Item>

        {(currentImage || previewImage) && (
          <Form.Item label="Ảnh sản phẩm hiện tại:">
            <Image width={150} src={previewImage || currentImage} />
          </Form.Item>
        )}

        <Form.Item label="Chọn ảnh mới (nếu cần):">
          <Upload
            beforeUpload={() => false} // Không upload ngay lập tức
            onChange={handleFileChange}
            onRemove={() => {
              setPreviewImage(""); // Khi xóa ảnh, đặt lại previewImage
              setSelectedFile(null);
            }}
            listType="picture"
            maxCount={1} // Chỉ cho phép chọn 1 ảnh
          >
            <Button icon={<UploadOutlined />}>Chọn ảnh</Button>
          </Upload>
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default ProductModal;
